import { apiClient } from './client';
import { TeamMember } from '../types';

export async function getTeamMembers(): Promise<{ data: TeamMember[] }> {
  const { data } = await apiClient.get<{ data: TeamMember[] }>('/team-members');
  return data;
}

export async function getTeamMember(id: string): Promise<{ data: TeamMember }> {
  const { data } = await apiClient.get<{ data: TeamMember }>(`/team-members/${id}`);
  return data;
}

export async function createTeamMember(payload: Partial<TeamMember>): Promise<{ data: TeamMember }> {
  const { data } = await apiClient.post<{ data: TeamMember }>('/team-members', payload);
  return data;
}

export async function updateTeamMember(id: string, payload: Partial<TeamMember>): Promise<{ data: TeamMember }> {
  const { data } = await apiClient.put<{ data: TeamMember }>(`/team-members/${id}`, payload);
  return data;
}

export async function deleteTeamMember(id: string): Promise<void> {
  await apiClient.delete(`/team-members/${id}`);
}
